import { useMemo } from 'react';

import { COUNTRY_ALIASES, SUPPORTED_COUNTRIES } from './constants';

export function useFilteredCountries(searchTerm: string) {
  const filteredCountries = useMemo(() => {
    if (!searchTerm) {
      return SUPPORTED_COUNTRIES;
    }

    return SUPPORTED_COUNTRIES.filter(({ name, code, countryCallingCode }) => {
      const normalisedSearchTerm = searchTerm.toLowerCase();
      const codeMatch = code.toLowerCase().includes(normalisedSearchTerm);
      const nameMatch = name.toLowerCase().includes(normalisedSearchTerm);
      const countryCallingCodeMatch = countryCallingCode.includes(normalisedSearchTerm.replace('+', ''));
      const aliasMatch = COUNTRY_ALIASES[code]?.some((alias) =>
        alias.toLowerCase().includes(normalisedSearchTerm),
      );

      return codeMatch || nameMatch || countryCallingCodeMatch || aliasMatch;
    });
  }, [searchTerm]);

  return filteredCountries;
}
